import { render, staticRenderFns } from "./SemaforoTiempo.vue?vue&type=template&id=74d585ca&scoped=true"
import script from "./SemaforoTiempo.vue?vue&type=script&lang=js"
export * from "./SemaforoTiempo.vue?vue&type=script&lang=js"
import style0 from "./SemaforoTiempo.vue?vue&type=style&index=0&id=74d585ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d585ca",
  null
  
)

export default component.exports